// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2019-06-19 10:23:40 +0200 (Wed, 19 Jun 2019) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 101664 $
//  Purpose   : MODS related sagas
// =============================================================================
// ---Third-party imports
import {takeEvery, put} from 'redux-saga/effects'

// ---Framework imports
import {Actions} from 'uix/registries'
import Api from 'uix/api'
import log from 'uix/logging'

// ---Local imports
import {saveMods, saveModsSuccess} from './actions'

// ---Globals
function* _saveMods({payload}) {
  let {otid, text, validate = true} = payload
  let {data, error} = yield Api.post('/api/saveModsXML', {otid, text, validate})

  if (error) {
    yield put(Actions.errorNotification({error, header: 'Mods Save Error'}))
  } else {
    if (data.status == 'error') {
      // validation error
      if (data.validationErrors) {
        let error = {errorMsg: data.validationErrors.join('\n')}
        yield put(Actions.errorNotification({error, header: 'Validation Error'}))
      } else {
        let error = {errorMsg: 'unknown'}
        yield put(Actions.errorNotification({error, header: 'Mods Save Error'}))
      }
    } else {
      yield put(Actions.successNotification({message: 'MODS saved.'}))
      yield put(saveModsSuccess(otid, text))
    }
  }
}

export const sagas = {
  saveMods: takeEvery(saveMods, _saveMods),
}
